const isWindowUndefined = typeof window === 'undefined';

export default isWindowUndefined;
